module.exports = __webpack_public_path__ + "static/media/sofia-hit.d51647a5.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/sofia-hit.png
// module id = 43
// module chunks = 0